module.exports = __webpack_public_path__ + "img/flag_in.6d9b2b5.png";